import { createFileRoute } from '@tanstack/react-router'

import { PedidoPorCodigo } from '@/components/gestor/recuperacao/PedidoPorCodigo'

/*
 * `/gestor/esqueci-senha/codigo`: tela pública (sem sessão), aberta pelo link do e-mail ou pela entrada.
 * A guarda da rota-mãe a deixa abrir por estar na lista de caminhos públicos.
 */
export const Route = createFileRoute('/gestor/esqueci-senha/codigo')({ component: PedidoPorCodigo })
